import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDirectIncomeBalanceApi } from "../../../apiservice/reports";
import { getAccountBySeachApi } from "../../../apiservice/setting";

export const fetchDirectIncomeBalance = createAsyncThunk(
  "directIncomeBalance/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        accId: filters?.accId || null,
        fromDate: filters?.fromDate || null,
        toDate: filters?.toDate || null,
      };
      const res = await getDirectIncomeBalanceApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchDirectIncomeAccountsBySearch = createAsyncThunk(
  "directIncomeBalance/fetchAccountsBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: search.trim(),
        multiType: ["direct_income"],
      });
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,
        display_text: c.acc_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
